import { render, staticRenderFns } from "./OrderableErrorReasonMessage.vue?vue&type=template&id=0f7b54c2&"
import script from "./OrderableErrorReasonMessage.vue?vue&type=script&lang=ts&"
export * from "./OrderableErrorReasonMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports